export const MAX_PERSON_NAME = 200

export const MAX_CONTACT = 500

export const MAX_NOTES = 2000

export const MAX_QUESTION_LABEL = 500

export const MAX_OPTION_LABEL = 200

export const MAX_TITLE = 200

export const MAX_LOCATION = 200

export const MAX_PLACE_NAME = 100

export const MAX_EMOJI = 16

export const MAX_DESCRIPTION = 20_000

export const MAX_COMMENT = 2000

export const MAX_POST = 8000

export const MAX_INTRODUCTION = 10_000

export const MAX_SLUG = 64

export const MAX_WELCOME_LENGTH = 100_000

export const MAX_FAQ_QUESTION = 500

export const MAX_FAQ_ANSWER = 100_000

export const MAX_PASSKEY_LABEL = 100

export const MAX_SMTP_HOST = 253

export const MAX_SMTP_USERNAME = 320

export const MAX_SMTP_PASSWORD = 500

export const MAX_EMAIL = 254

export const MAX_FROM_NAME = 200

export const MAX_RIDE_PLACE = 120

export const MAX_CONNECTION_VALUE = 200

export const MAX_CONNECTION_LABEL = 60

export const MAX_CONNECTIONS = 12

export const MAX_SONG_BODY = 20_000

export const MAX_SONG_LINKS = 8

export const MAX_SONG_LINK_URL = 500

export const MAX_SONG_CATEGORIES = 8

export const MAX_CAPO = 11

export const MAX_MAP_URL = 500

export const MAX_OAUTH_CLIENT_ID = 200

export const MAX_OAUTH_CLIENT_SECRET = 500

export const MAX_INVITE_LABEL = 80

export const MAX_GROUP_INVITE_USES = 200

export const MIN_PASSWORD = 10

export const RESET_VALID_HOURS = 2

export const MAX_MEETING_LINK = 500

export const MAX_DECIDED_NOTE = 200

export const DIGEST_PREVIEW_HOURS = 24

export const MOST_PREVIEW_HOURS = 24 * 90

export const MAX_UNIT = 20

export const MAX_SPOT = 100

export const MAX_PANTRY_NOTE = 500

export const MAX_REMINDER_SUBJECT = 150

export const MAX_REMINDER_BODY = 5000
